import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterOutlet } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { NavTopSecure } from "../../components/nav-top-secure/nav-top-secure";
import { AsideHeader } from "../../components/aside-header/aside-header";
import { NavAside } from "../../components/nav-aside/nav-aside";
import { environment } from '../../../environments/environment';

@Component({
  selector: "app-secure-layout",
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    FormsModule,
    NavTopSecure,
    AsideHeader,
    NavAside,
  ],
  templateUrl: "./secure-layout.component.html",
  styleUrls: ["./secure-layout.component.scss"],
})
export class SecureLayoutComponent {
  showDrawer = false;

  toggleDrawer() {
    this.showDrawer = !this.showDrawer;
  }

  protected readonly environment = environment;
}
